import script from "./BatchDeleteCategoryForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchDeleteCategoryForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__